export const RETRYABLE_STATUS_CODES = [408, 429, 500, 502, 503, 504]

export const RETRY_MAX_ATTEMPTS = 4

export const RETRY_INITIAL_DELAY_MS = 500

export const RETRY_MAX_DELAY_MS = 30_000
